import { render } from "./TestKanbanStage.vue?vue&type=template&id=295f8d8d&scoped=true"
import script from "./TestKanbanStage.vue?vue&type=script&lang=js"
export * from "./TestKanbanStage.vue?vue&type=script&lang=js"

import "./TestKanbanStage.vue?vue&type=style&index=0&id=295f8d8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295f8d8d"]])

export default __exports__